import React, { Component } from 'react'
import { Modal } from 'hljd'
import Map from '@common/Map'
import { observer } from 'mobx-react'
import store from './store'

@observer
export default class extends Component {
  handleOk = myStore => () => {
    store.submit(myStore)
  }

  handleCancel() {
    store.cancel()
  }

  getMap(map, marker) {
    store.getMap(map, marker)
  }

  getPosition = (point, address) => {
    store.point = point
    store.address = address
  }

  inputChange = value => {
    const { myStore } = this.props
    myStore.address = value
  }

  render() {
    const { myStore } = this.props
    const { visible } = store
    const { address } = myStore

    return (
      <Modal
        visible={visible}
        closable={false}
        onOk={this.handleOk(myStore)}
        onCancel={this.handleCancel}
      >
        <div>
          <Map
            isShowToolBar
            isClick
            getPosition={this.getPosition}
            inputChange={this.inputChange}
            afterRender={this.getMap}
            address={address}
            visible={'block'}
          />
        </div>
      </Modal>
    )
  }
}
